module.exports = __webpack_public_path__ + "img/frame-landscape.14d89344.svg";